(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbl-product-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function readVariants(root) {
    var el = root.querySelector('[data-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function selectedValues(root) {
    var vals = [];
    root.querySelectorAll('.vbl-pp__opt').forEach(function (f) {
      var c = f.querySelector('input:checked');
      vals[parseInt(f.dataset.index, 10)] = c ? c.value : null;
    });
    return vals;
  }

  function findVariant(variants, vals) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var k = 0; k < variants[i].options.length; k++) {
        if (variants[i].options[k] !== vals[k]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  function markSoldOut(root, variants) {
    var vals = selectedValues(root);
    root.querySelectorAll('.vbl-pp__opt').forEach(function (f) {
      var idx = parseInt(f.dataset.index, 10);
      f.querySelectorAll('input').forEach(function (inp) {
        var test = vals.slice();
        test[idx] = inp.value;
        var ok = variants.some(function (v) {
          return v.available && v.options.every(function (o, k) { return o === test[k]; });
        });
        var label = inp.nextElementSibling;
        if (label) label.classList.toggle('is-soldout', !ok);
      });
    });
  }

  function update(root) {
    var variants = readVariants(root);
    var vals = selectedValues(root);
    var variant = findVariant(variants, vals);
    var btn = root.querySelector('[data-add]');
    var label = root.querySelector('[data-add-label]');
    var idInput = root.querySelector('[data-variant-id]');

    markSoldOut(root, variants);

    if (!variant) {
      if (btn) { btn.disabled = true; }
      if (label && btn) { label.textContent = btn.dataset.labelUnavailable; }
      return;
    }

    if (idInput) idInput.value = variant.id;

    var price = root.querySelector('[data-price]');
    var compare = root.querySelector('[data-compare]');
    if (price) price.textContent = variant.price;
    if (compare) {
      compare.textContent = variant.compare;
      compare.hidden = !variant.onSale;
    }

    if (btn) {
      btn.disabled = !variant.available;
      if (label) label.textContent = variant.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    var track = root.querySelector('[data-track]');
    if (variant.media && track && window.matchMedia('(max-width: 989px)').matches) {
      var slide = root.querySelector('[data-media-id="' + variant.media + '"]');
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }

  function renderDelivery(root) {
    var el = root.querySelector('[data-delivery]');
    if (!el) return;
    var min = parseInt(el.dataset.min, 10) || 0;
    var max = parseInt(el.dataset.max, 10) || 0;
    var template = el.dataset.template || '';
    var lang = document.documentElement.lang || 'es';
    var opts = { weekday: 'short', day: 'numeric', month: 'short' };
    var now = new Date();
    var from = addBusinessDays(now, min).toLocaleDateString(lang, opts);
    var to = addBusinessDays(now, max).toLocaleDateString(lang, opts);
    var parts = template.split(/(\{from\}|\{to\})/);
    el.textContent = '';
    parts.forEach(function (part) {
      if (part === '{from}' || part === '{to}') {
        var s = document.createElement('strong');
        s.textContent = part === '{from}' ? from : to;
        el.appendChild(s);
      } else if (part) {
        el.appendChild(document.createTextNode(part));
      }
    });
  }

  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    markSoldOut(root, readVariants(root));
    renderDelivery(root);
  }

  function initAll() {
    document.querySelectorAll('.vbl-pp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.vbl-pp__opt input')) return;
    var root = e.target.closest('.vbl-pp');
    if (root) update(root);
  });

  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('[data-dot]') : null;
    if (!dot) return;
    var root = dot.closest('.vbl-pp');
    var track = root && root.querySelector('[data-track]');
    if (!track) return;
    var i = parseInt(dot.dataset.dot, 10);
    track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-track]')) return;
    var root = track.closest('.vbl-pp');
    if (!root || !track.clientWidth) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    root.querySelectorAll('[data-dot]').forEach(function (d) {
      d.classList.toggle('is-active', parseInt(d.dataset.dot, 10) === index);
    });
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
